import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { adminApi} from "./metricsApi";

export const store = configureStore({
    reducer: {
        [adminApi.reducerPath]: adminApi.reducer,
    },
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }).concat(adminApi.middleware),
});

// Optional: for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;